import React from "react";
import { Link as RouterLink } from "react-router-dom";

// InlineLink - For text links within paragraphs and content
export const InlineLink = ({
  children,
  to,
  href,
  external = false,
  className = "",
  variant = "primary",
  ...props
}) => {
  const variants = {
    primary:
      "text-blue-400 hover:text-blue-300 underline transition-colors duration-200",
    secondary:
      "text-[var(--color-highlight-yellow)] hover:text-yellow-300 underline transition-colors duration-200",
    subtle:
      "text-[var(--color-secondary)] hover:text-white underline transition-colors duration-200 opacity-75 hover:opacity-100",
  };

  const baseClasses = `${variants[variant]} ${className}`.trim();

  // External link
  if (external || href) {
    return (
      <a
        href={href || to}
        target="_blank"
        rel="noopener noreferrer"
        className={baseClasses}
        {...props}
      >
        {children}
      </a>
    );
  }

  // Internal React Router link
  return (
    <RouterLink to={to} className={baseClasses} {...props}>
      {children}
    </RouterLink>
  );
};

export default InlineLink;
